import { Moment } from 'moment';
import { TransportType } from './transport-type';
import { TravelType } from './travel-type';

export class Travel {

    constructor(
        public id: number,
        public travelType: TravelType,
        public flightNumber: string,
        public departureAirport: string,
        public departureDate: Moment,
        public departureTime: string | null,
        public arrivalDate: Moment,
        public arrivalAirport: string,
        public arrivalTime: string | null,
        public isDeleted: boolean,
        public transportType: TransportType
    ){}
}
